<template>
  <div id="app" :class="{ container: !isFullBleed, 'memories-route': isMemoriesRoute }">
    <div :style="isFullBleed ? { padding: '1rem 1.5rem 0' } : {}">
      <navbar></navbar>
    </div>
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Navbar from '@/components/Navbar.vue'
import ClientStorageService from './services/client-storage-services'

export default defineComponent({
  name: 'App',

  components: {
    Navbar,
  },

  computed: {
    isFullBleed(): boolean {
      return this.$route.name === 'End';
    },
    isMemoriesRoute(): boolean {
      return this.$route.path.includes('/memories')
    },
  },

  mounted() {
    const twoDays = 48 * 60 * 60 * 1000
    const activationDate = ClientStorageService.getHuntActivationDateTime()

    if (
      activationDate &&
      new Date().valueOf() >
        JSON.parse(activationDate).valueOf() + twoDays
    ) {
      ClientStorageService.clearHuntCache()
    }
  },
})
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #269484;
$primary-invert: findColorInvert($primary);
$secondary: #2594a1;
$secondary-invert: findColorInvert($secondary);
$info: #ce6362;
$info-invert: findColorInvert($info);
// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black,
  ),
  "black": (
    $black,
    $white,
  ),
  "primary": (
    $primary,
    $primary-invert,
  ),
  "secondary": (
    $secondary,
    $secondary-invert,
  ),
  "info": (
    $info,
    $info-invert,
  ),
  "success": (
    $success,
    $success-invert,
  ),
  "warning": (
    $warning,
    $warning-invert,
  ),
  "danger": (
    $danger,
    $danger-invert,
  ),
);

// Import Bulma and Buefy styles
@import "~bulma";

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

$page-padding: 1.5rem;

#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  box-sizing: border-box;

  > .container {
    width: 100%;
    padding: $page-padding;
    box-sizing: border-box;
  }

  p {
    padding-bottom: 1.5rem;
  }

}

// Remove app margin only on /memories routes, and only on phones
@media screen and (max-width: 768px) {
  #app:has(> .container.memories-route) {
    > .container {
      padding: 0;
    }
  }
}

#app.container {
  max-width: 1200px;
  margin: 1.5rem auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-bottom: 1.5rem;
}
</style>
